import { useState, type ReactNode } from "react";

/* Napparivi (T651, Toni 23.10.2026 klo 12.15): näkymän harvoin käytetyt toiminnot yhdellä rivillä. Koko teksti on nappi — erillistä
   «Avaa»-nappia ei ole. Painallus avaa toiminnon paneelin rivin alle, yksi kerrallaan; sama nappi uudelleen sulkee. Avoin nappi näkyy
   painettuna (aria-expanded), ja kapealla näytöllä napit rivittyvät (flex-wrap) eikä sivulle tule vaakavieritystä.
   Kutsuja päättää, mitkä toiminnot näytetään (oikeudet): tyhjä lista → ei riviä lainkaan. */
export interface NappiriviToiminto { avain: string; nimi: string; sisalto: () => ReactNode }

export default function Napparivi({ nimi, toiminnot }: { nimi: string; toiminnot: NappiriviToiminto[] }) {
  const [auki, setAuki] = useState<string | null>(null);
  if (!toiminnot.length) return null;
  const avoin = toiminnot.find((x) => x.avain === auki) ?? null;
  return (
    <div className="napparivi__runko">
      <div className="napparivi" role="toolbar" data-napparivi={nimi}>
        {toiminnot.map((x) => (
          <button key={x.avain} type="button" className="nappi nappi--kevyt napparivi__nappi" data-toiminto={x.avain}
                  aria-expanded={auki === x.avain} onClick={() => setAuki((a) => (a === x.avain ? null : x.avain))}>
            {x.nimi}
          </button>
        ))}
      </div>
      {avoin && <div className="napparivi__paneeli" data-toimintopaneeli={avoin.avain}>{avoin.sisalto()}</div>}
    </div>
  );
}
